import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  OnDestroy,
} from '@angular/core';

@Component({
  selector: 'app-az-selector',
  standalone: true,
  imports: [],
  templateUrl: './az-selector.component.html',
  styleUrl: './az-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AzSelectorComponent implements OnDestroy {
  @Input() label = '';
  @Input() options: string[] = [];
  @Input() selectedValue = '';
  @Input() disabled = false;
  @Output() selectionChange = new EventEmitter<string>();

  isOpen = false;
  private clickListener: ((event: MouseEvent) => void) | null = null;

  constructor(private elementRef: ElementRef) {}

  toggleDropdown(): void {
    if (this.disabled) return;

    this.isOpen = !this.isOpen;

    if (this.isOpen) {
      this.addClickListener();
    } else {
      this.removeClickListener();
    }
  }

  selectOption(option: string): void {
    this.selectedValue = option;
    this.selectionChange.emit(option);
    this.closeDropdown();
  }

  closeDropdown(): void {
    this.isOpen = false;
    this.removeClickListener();
  }

  private addClickListener(): void {
    // Remove existing listener if any
    this.removeClickListener();

    // Add listener in next tick to avoid immediate trigger
    setTimeout(() => {
      this.clickListener = (event: MouseEvent) => {
        const target = event.target as Node;
        if (!this.elementRef.nativeElement.contains(target)) {
          this.closeDropdown();
        }
      };
      document.addEventListener('click', this.clickListener, true);
    }, 0);
  }

  private removeClickListener(): void {
    if (this.clickListener) {
      document.removeEventListener('click', this.clickListener, true);
      this.clickListener = null;
    }
  }

  ngOnDestroy(): void {
    this.removeClickListener();
  }
}
